import { useQuery } from '@tanstack/react-query';

import { useAuth } from 'context/AuthContext';
import { getRentedPlacesRequest } from '@/api';

function useGetRentedPlaces() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['rentedPlaces'],
    queryFn: getRentedPlacesRequest,
    initialData: [],
    enabled: isAuthenticated,
  });
}

export default useGetRentedPlaces;
